require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-astrada-reason-react-toolbox.json") })
        }
      }, "path---package-astrada-reason-react-toolbox");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-astrada-reason-react-toolbox!./.cache/json/package-astrada-reason-react-toolbox.json
// module id = 747
// module chunks = 231608221292675